import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { Subscription } from 'rxjs';
import { CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
@Component({
    selector: 'app-phone-input',
    templateUrl: './phone-input.component.html',
    styleUrls: ['./phone-input.component.css'],
    standalone: false
})
export class PhoneInputComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  @Input() form: UntypedFormGroup;
  @Input() fName = 'phoneNumber';
  @Output() phoneNumberChange: EventEmitter<string> =
    new EventEmitter<string>();
  ngOnInit(): void {
    this.subscriptions.add(
      this.phoneForm.controls.phone.valueChanges.subscribe((dat) => {
        if (dat) {
          this.form.controls[this.fName].setValue(dat.e164Number);
          if(!this.phoneForm.controls.phone.valid)
          {
            this.form.controls[this.fName].setErrors({ 'invalid': this.phoneForm.controls.phone.valid });
          }
          this.phoneNumberChange.emit(dat.e164Number);
        }
      })
    );
    if (this.form.controls[this.fName].value)
      this.phoneForm.controls.phone.patchValue(
        this.form.controls[this.fName].value
      );
    else {
      this.defaultContry = CountryISO.UnitedStates;
      this.selectedCountryCode = CountryISO.UnitedStates;
    }
    this.getPaceholder();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.Malta,
    CountryISO.Netherlands,
    CountryISO.Canada,
    CountryISO.India,
  ];
  selectedCountryCode;
  defaultContry;
  countryChange($event) {
    this.selectedCountryCode = $event.iso2;
    this.getPaceholder();
  }
  placeholder;
  getPaceholder() {
    const examplePhone = getExampleNumber(
      this.selectedCountryCode?.toUpperCase() as CountryCode,
      examples
    );
    this.placeholder = examplePhone?.formatNational();
  }
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });
  get phoneControl(): FormControl {
    return this.phoneForm.get('phone') as FormControl;
  }
}
